import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_FACILITY_LIST = "GET_FACILITY_LIST";

export const service = async (auditGroupId) => {
  const options: object = {
    url: "/api/Facility/GetFacilityListStratification/" + auditGroupId,
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_FACILITY_LIST, service, mock);
